<template>
<div class="card">
  <div class="search-box">
    <span class="header">渠道商信息</span>
    <div class="item">
      <span><label>渠道商账号名：</label>{{c.alias}}</span>
      <span><label>渠道商账号：</label>{{c.account}}</span>
    </div>
    <div class="item"><label>{{$route.query.title}}：</label>{{c.totalFrozenFund||c.accountCost||c.creditCost||'0'}}&nbsp元</div>
  </div>
  <div class="list" style="background:rgba(255,255,255,1); padding:24px">
    <span class="header">相关订单</span>
		<order-list :data="data" :pagination="pagination" :orderType="orderType"></order-list>
  </div>
</div>
  
</template>
<script>
import OrderList from "@/components/OrderList";

export default {
  name:'fundlist',
	components:{OrderList},
  data() {
    return {
      c:{},
      data:[],
      orderType:"2",
      pagination: {
        total:0,
        current:1,
        pageSize:10,
        onChange: page => {
          this.pagination.current = page;
          this.getdata && this.getdata();
        },
      },
    };
  },
 activated(){
    let title = this.$route.query.title;
    if (title == "冻结资金") {
      this.orderType = "2";
    } else if(title == "已用资金") {
      this.orderType = "3";
    } else if(title == "授信金额") {
      this.orderType = "4";
    }
    let meta = this.$route.meta;
    if (!meta.keepAlive) {
      this.pagination.current = 1;
      this.getdata()
    }
 }, 
 beforeRouteEnter(to,from,next){
    if(from.name !== 'order-channel'){//不是从detail页面过来的，需要刷新
        to.meta.keepAlive = false;
    }else{
      to.meta.keepAlive = true;
    }
    next()
},
 beforeRouteLeave(to,from,next){
    if(to.name !== 'order-channel') {//不去详情页面时，将缓存的listData数组清空
        this.data = []
    }
    next()
},
  methods:{
    reset(){
      this.searchTerm = {};
      this.getdata();
    },
    getdata(){
      let params = {
        pageNum : this.pagination.current,
        distributorId:this.$route.query.id,
      }
      const title = this.$route.query.title;
      let   url = ''
      if (title == '冻结资金') {
        url = 'distCost/queryFrozenFundOrder'
      } else if(title == '已用资金'){
        url = 'distCost/queryAccountCostOrder'
      }else if (title == '授信金额') {
        url = 'distCost/queryCreditCostOrder'
      }
      this.$http.post(url,'',{params}).then(res=>{
        if (res.result) {
          this.data = res.rows
          this.c = res.data;
          this.pagination.total = res.count;
        } 
      })
    },
    openModal(index){
      this.$router.push({name:'frozen-detail',query:{id:index,btitle:this.$route.query.title}})
    }
  }
};
</script>
<style lang="less" scoped>

.list{
  .header{
    display: inline-block;
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
    margin-bottom: 16px;
  }
}
.card{
  margin:0 24px;
  // padding: 24px;
}
/deep/.ant-list-lg .ant-list-item {
    padding-top: 0;
}
.search-box{
  background:rgba(255,255,255,1);
  label{
    display:inline-block;
    width: 98px;
    text-align: right;
  }
  .header{
    font-size:16px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(0,0,0,0.85);
    line-height:24px;
  }
  span{
      display: inline-block;
      padding: 8px 0 ;
    }
  .item{
    span{
      padding-right:180px;
    }
  }
  
}


.ant-list-split .ant-list-item {
    border: 1px solid #e8e8e8;
    // border-bottom: 0;
    margin-bottom: 12px;
}
/deep/.ant-list-split .ant-list-header {
    /* border-bottom: 1px solid #e8e8e8; */
    margin-bottom: 12px;
    background-color: #FAFAFA;
}

.order-detail{
    display: flex;
    // justify-content: center;
    align-items: center;
}
</style>
